import React, { Component, Fragment } from 'react';
import { Button, Form, Grid, Input } from 'semantic-ui-react';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { UpdateBidPriceDetailsEnum } from 'Common/FieldEnum';
import { normalizeInput } from '../helpers';

export default class LevelContainer extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    disabled: false,
  };
  onAddClick = index => {
    const { input } = this.props;
    const values = [
      ...input.value,
      {
        [UpdateBidPriceDetailsEnum.FromBracket]: '',
        [UpdateBidPriceDetailsEnum.ToBracket]: null,
        [UpdateBidPriceDetailsEnum.Price]: '0.0000',
      },
    ];
    values[index].ToBracket = '';
    input.onChange(values);
  };
  onDeleteClick = index => {
    const { input } = this.props;
    const values = _.cloneDeep(input.value);
    if (index >= 2) {
      values[index - 1].ToBracket = null;
    }
    values.splice(index, 1);
    input.onChange(values);
  };
  handleChange = (index, { value }, fieldName) => {
    const { input } = this.props;
    const values = _.cloneDeep(input.value);
    const normalizedValue = normalizeInput(value, fieldName);
    values[index][fieldName] = normalizedValue;
    if (fieldName === UpdateBidPriceDetailsEnum.ToBracket) {
      values[index + 1][UpdateBidPriceDetailsEnum.FromBracket] =
        +normalizedValue + 1;
      values[index].toError = false;
    } else if (fieldName === UpdateBidPriceDetailsEnum.Price) {
      values[index].priceError = false;
    }
    input.onChange(values);
  };
  render() {
    const { disabled, input } = this.props;
    const length = input.value ? input.value.length : 0;
    return (
      <Form.Field>
        {_.map(input.value, (item, index) => (
          <Grid key={index} style={{ marginTop: 0 }}>
            <Grid.Row columns={1}>
              <Grid.Column>
                <span className={'bidPriceItemName'}>Level{index + 1}:</span>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column>
                <label className="labelClass">From</label>
                <Input
                  name={UpdateBidPriceDetailsEnum.FromBracket + index}
                  maxLength={12}
                  type="text"
                  onChange={(e, data) =>
                    this.handleChange(
                      index,
                      data,
                      UpdateBidPriceDetailsEnum.FromBracket
                    )
                  }
                  value={item.FromBracket}
                  disabled={true}
                />
              </Grid.Column>
              <Grid.Column
                className={classNames({
                  'error field input--type-text ':
                    (!!item.ToBracket && item.ToBracket <= item.FromBracket) ||
                    item.toError,
                })}
              >
                {item.ToBracket !== null && (
                  <Fragment>
                    <label className="labelClass">To</label>
                    <Input
                      name={UpdateBidPriceDetailsEnum.ToBracket + index}
                      maxLength={12}
                      type="text"
                      onChange={(e, data) =>
                        this.handleChange(
                          index,
                          data,
                          UpdateBidPriceDetailsEnum.ToBracket
                        )
                      }
                      disabled={disabled}
                      value={item.ToBracket}
                    />
                    <div
                      style={{ height: 10 }}
                      className={'input--message input--message-error'}
                    >
                      {(!!item.ToBracket &&
                        item.ToBracket <= item.FromBracket) ||
                      item.toError
                        ? 'Value should be greater than From.'
                        : ''}
                    </div>
                  </Fragment>
                )}
              </Grid.Column>
              <Grid.Column
                className={classNames({
                  'error field input--type-text ':
                    !item[UpdateBidPriceDetailsEnum.Price] || item.priceError,
                })}
              >
                <label className="labelClass">Price: $</label>
                <Input
                  name={UpdateBidPriceDetailsEnum.Price + index}
                  maxLength={8}
                  type="text"
                  onChange={(e, data) =>
                    this.handleChange(
                      index,
                      data,
                      UpdateBidPriceDetailsEnum.Price
                    )
                  }
                  disabled={disabled}
                  value={item[UpdateBidPriceDetailsEnum.Price]}
                />
                <div
                  style={{ height: 10 }}
                  className={'input--message input--message-error'}
                >
                  {!item[UpdateBidPriceDetailsEnum.Price] || item.priceError
                    ? 'Price is required! Please Enter Price value.'
                    : ''}
                </div>
              </Grid.Column>
              {index === length - 1 ? (
                <Grid.Column verticalAlign={'top'} style={{ top: 25 }}>
                  <Button
                    icon="plus"
                    disabled={disabled}
                    type={'button'}
                    onClick={() => this.onAddClick(index)}
                  />
                  {length > 2 && (
                    <Button
                      icon="minus"
                      disabled={disabled}
                      type={'button'}
                      onClick={() => this.onDeleteClick(index)}
                    />
                  )}
                </Grid.Column>
              ) : null}
            </Grid.Row>
          </Grid>
        ))}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/containers/LevelContainer.js